import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';


import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';

import { RouteData } from './app-routing.module';
import { RouteLogService } from './common-app/service/route-log.service';

@Component({
  selector: 'sun-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  title = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private routeLogService: RouteLogService,
  ) { }

  ngOnInit() {

    // 画面遷移後に、タイトルを変更する処理
    this.router.events
      .filter((event: any) => event instanceof NavigationEnd)
      .map(() => this.route)
      .map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        this.routeLogService.log(route, 'kvaw1200');
        return route;
      })
      .filter((route) => route.outlet === 'primary')
      .mergeMap((route) => route.data)
      .subscribe((data: RouteData) => this.title = data.title);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts